import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    // null until the theme is read, so the class set by index.html's early script survives hydration.
    const [theme, setTheme] = useState(null);
    const isDarkMode = theme === true;

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        const nextIsDarkMode = document.documentElement.classList.contains("dark");
        const rafId = window.requestAnimationFrame(() => {
            setTheme(nextIsDarkMode);
        });
        return () => window.cancelAnimationFrame(rafId);
    }, []);

    useEffect(() => {
        if (typeof document === "undefined" || theme === null) {
            return;
        }
        const root = document.documentElement;
        root.classList.toggle("dark", theme);
        root.style.colorScheme = theme ? "dark" : "light";
    }, [theme]);

    const toggleDarkMode = () => {
        const newMode = !isDarkMode;
        setTheme(newMode);
        if (typeof window !== "undefined") {
            window.localStorage.setItem("theme", newMode ? "dark" : "light");
        }
    };

    return (
        <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

ThemeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useTheme = () => useContext(ThemeContext);
